export default {
    methods: {
        folderColor(data) {
            return data.relate ? '#409EFF' : data.status == 0 ? '#C0C4CC' : '#606266'
        }
    },
}


// WEBPACK FOOTER //
// ./src/views/oa_catalog/folder-mixin.js